import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import client from "../client";
import { handleToast } from "../../utils/functions";
import handleApiError from "../../hooks/handleApiError";
import { setUserDetails } from "../../../redux/slices/auth/slice";

export default function useRegisterTeacherBySchoolInvitation() {
    const { inviteId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const request = useCallback(
        async (payload) => {
            try {
                setLoading(true);

                const { data } = await client.post(
                    `/auth/registration/invite/${inviteId}`,
                    payload
                );

                localStorage.setItem("token", data?.data?.token);
                dispatch(setUserDetails(data?.data?.user));

                handleToast(data?.message);
                setLoading(false);
                navigate(`/${data?.data?.user?.schoolId}/dashboard`);
            } catch (error) {
                setLoading(false);
                handleApiError(error);
            }
        },
        [dispatch, inviteId, navigate]
    );

    return { request, loading };
}
